import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="empty-screen">
      <div className="inner_terms_content" style={{ color: "#323232" }}>
        <div className="inner_header"></div>
        <p>
          <strong>Dreamer Diaries – Terms and Conditions</strong>
        </p>
        <p>
          <strong>Effective Date: 2024-06-19</strong>
        </p>
        <p>
          <strong>1. License and Ownership</strong>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            The Service Provider grants you a limited, non-exclusive,
            non-transferable, revocable license to use the Application for
            personal, non-commercial use only. You may not modify,
            reverse-engineer, decompile, or attempt to extract the source code
            of the Application. All trademarks, copyrights, database rights, and
            intellectual property rights related to the Application remain the
            exclusive property of the Service Provider.
          </span>
        </p>
        <p>
          <strong>2. Intellectual Property & Third-Party Content</strong>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            The Diamond Diaries app is a personal logbook designed for users to
            track their diamond painting projects. Dreamer Designs does not
            claim ownership of any third-party brand names, trademarks, or
            copyrighted materials that users may reference within the app.
          </span>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            By using the app, you acknowledge that:{" "}
          </span>
        </p>
        <ul>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              You may enter details about any diamond painting project,
              regardless of brand, for personal tracking purposes only.
            </span>
          </li>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              Dreamer Designs is not affiliated with, endorsed by, or in
              partnership with any other diamond painting brand unless
              explicitly stated.
            </span>
          </li>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              You are solely responsible for ensuring that any images or content
              you upload do not infringe on copyrights, trademarks, or other
              intellectual property rights of third parties.
            </span>
          </li>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              Any unauthorized use of copyrighted or trademarked material is
              strictly prohibited.
            </span>
          </li>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              Dreamer Designs reserves the right to remove any content that
              violates these terms and may suspend access to users who
              repeatedly infringe on intellectual property rights.
            </span>
          </li>
        </ul>
        <p>
          <strong>3. User-Generated Content & Responsibility</strong>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            The Application allows users to log their diamond painting projects,
            including those from other brands.
          </span>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            You agree that you will not upload, share, or store any content
            that:
          </span>
        </p>
        <ul>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              Violates copyright, trademark, or other intellectual property
              rights of third parties.
            </span>
          </li>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              Contains offensive, misleading, or illegal material.
            </span>
          </li>
        </ul>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            The Service Provider is not liable for user-uploaded content and
            reserves the right to remove any content that violates these Terms.
          </span>
        </p>

        <p>
          <strong>4. Data Collection & Security</strong>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            The Application stores and processes personal data in accordance
            with our Privacy Policy.
          </span>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            You are responsible for securing your account credentials and device
            access.
          </span>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            Jailbreaking or rooting your device may compromise security and void
            your access to the Application.
          </span>
        </p>
        <p>
          <strong>5. Third-Party Services</strong>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            The Application may integrate with third-party services:
          </span>
        </p>
        <ul>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <a href="https://policies.google.com/terms">
              <span style={{ fontWeight: 400, color: "#1500ef" }}>
                Google Play Services
              </span>
            </a>
          </li>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <a href="https://firebase.google.com/terms/crashlytics">
              <span style={{ fontWeight: 400, color: "#1500ef" }}>
                Firebase Crashlytics
              </span>
            </a>
          </li>
        </ul>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            These services have their own Terms and Conditions, and the Service
            Provider is not responsible for their policies or actions.
          </span>
        </p>
        <p>
          <strong>6. Connectivity & Charges</strong>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            Some features of the Application require an active internet
            connection.
          </span>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            You are responsible for any mobile data charges, including roaming
            fees.
          </span>
        </p>
        <p>
          <strong>7. Disclaimers & Limitation of Liability</strong>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            The Application is provided "as is" and without warranties of any
            kind.
          </span>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            The Service Provider does not guarantee uninterrupted access or
            error-free operation.
          </span>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            The Service Provider is not responsible for:
          </span>
        </p>
        <ul>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              Loss of user data due to technical failures.
            </span>
          </li>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              Issues arising from third-party services.
            </span>
          </li>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              Any damages resulting from reliance on the Application's
              functionalities.
            </span>
          </li>
        </ul>
        <p>
          <strong>8. Report IP Violations</strong>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            If you believe that content within the Application infringes upon
            your intellectual property rights, please report it promptly.
          </span>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            To report an IP violation, contact us at support@dreamerdesigns.com
            with:
          </span>
        </p>
        <ul>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              A detailed description of the alleged infringement.
            </span>
          </li>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              A link or reference to the infringing content.
            </span>
          </li>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              Proof of ownership (e.g., registration certificates, links to
              original works).
            </span>
          </li>
          <li style={{ fontWeight: 400, color: "#323232" }}>
            <span style={{ fontWeight: 400, color: "#323232" }}>
              Your full name, contact information, and a statement confirming
              that the information is accurate and that you are the IP owner or
              authorized representative.
            </span>
          </li>
        </ul>
        <p>
          <strong>9. Termination & Service Modifications</strong>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            The Service Provider reserves the right to modify, discontinue, or
            limit access to the Application at any time without prior notice.
          </span>
        </p>
        <p>
          <strong>10. Changes to These Terms</strong>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            These Terms may be updated periodically. Continued use of the
            Application after changes are posted constitutes acceptance of the
            new Terms.
          </span>
        </p>
        <p>
          <strong>11. Contact Us</strong>
        </p>
        <p>
          <span style={{ fontWeight: 400, color: "#323232" }}>
            For questions or concerns regarding these Terms, contact us at
            support@dreamerdesigns.com.{" "}
          </span>
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
